var _defs, _path, _path2, _path3, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupplierOffers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.19 147.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-215,444.5a44.89,44.89,0,0,1-.3,5.09h-86.17a40.92,40.92,0,0,1-.3-5.09,43.32,43.32,0,0,1,15.43-33.18,6.42,6.42,0,0,1,7.89-.14,34.21,34.21,0,0,0,20.05,6.45,34.23,34.23,0,0,0,21.18-7.28,4.63,4.63,0,0,1,5.69.08A43.31,43.31,0,0,1-215,444.5Z",
    transform: "translate(301.75 -302.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-231.42,384.4a26.68,26.68,0,0,1-10.42,21.16,26.66,26.66,0,0,1-16.28,5.54,26.84,26.84,0,0,1-16.45-5.66,26.67,26.67,0,0,1-10.25-21,26.68,26.68,0,0,1,26.69-26.69,26.68,26.68,0,0,1,26.69,26.69Z",
    transform: "translate(301.75 -302.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-240.73,315.36A10.39,10.39,0,0,1-230.37,305h56a10.38,10.38,0,0,1,10.35,10.36v29.85a10.37,10.37,0,0,1-10.35,10.36h-36.35L-226,363.72v-8.15h-4.34a10.37,10.37,0,0,1-10.35-10.36V315.36Z",
    transform: "translate(301.75 -302.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.05,
    y: 15.59,
    width: 53,
    height: 6,
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.55,
    y: 26.09,
    width: 53,
    height: 6,
    rx: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.55,
    y: 35.09,
    width: 29,
    height: 6,
    rx: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierOffers);
export default __webpack_public_path__ + "static/media/SupplierOffers.b96dea57c1fa38fb5067912d13225eee.svg";
export { ForwardRef as ReactComponent };